import { render, staticRenderFns } from "./vFormCHECKBOXES.vue?vue&type=template&id=0fb017d8&scoped=true&"
import script from "./vFormCHECKBOXES.vue?vue&type=script&lang=js&"
export * from "./vFormCHECKBOXES.vue?vue&type=script&lang=js&"
import style0 from "./vFormCHECKBOXES.vue?vue&type=style&index=0&id=0fb017d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb017d8",
  null
  
)

export default component.exports